import { number, string, node, oneOfType, arrayOf } from "prop-types";
const children = oneOfType([arrayOf(node), node]);
const responsiveStyle = oneOfType([
  number,
  string,
  arrayOf(oneOfType([number, string]))
]);
export {
  children,
  responsiveStyle
};
